import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UsersService } from '../@core/backend/common/services/users.service';

@Injectable()
export class IsAuthenticated implements CanActivate {
  constructor(private authService: NbAuthService, private router: Router, private usersService: UsersService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {

    if (environment.useCookies) { // Cookie use activation
      const raw = localStorage.getItem('currentUser');
      if (raw) {
        const currentUser = JSON.parse(raw);
        if (currentUser?.user) {
          this.router.navigate(['/pages/client/dashboard']);
          return false;
        }
      }
      return true;
    } else {
      return this.authService.isAuthenticated()
        .pipe(map(authenticated => {
          if (authenticated) {
            this.router.navigate(['/pages/client/dashboard']);
            return false;
          } else {
            return true;
          }
        }),
        );
    }
  }
}
